var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',_vm._l((_vm.list),function(item,index){return _c('section',{key:index},[_c('img',{attrs:{"src":item.image_url}}),_c('span',[_vm._v(_vm._s(item.item_dict_name))]),_c('router-link',{staticClass:"btn",attrs:{"to":{path: '/recuperate', query: {code: item.system_code, title: item.item_dict_name, ..._vm.query}}}},[_vm._v("查看")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }